import axios from "../../axios";

const URL = "/dashboard";

export const getAdminDashboardDetails = async () => {
  const response = await axios.get(`${URL}/adminDashboard`);
  return response.data;
};
